import React from "react";

const EventItem = ({ eventText }) => {
  return <p className="event-item">{eventText}</p>;
};

export const TimeLineBody = ({ events, age }) => {
  return (
    <div className="timeline-body">
      {events.map((event, index) => (
        <EventItem key={index} eventText={event} />
      ))}
    </div>
  );
};
